
export enum ShipmentManagementRemarkTypeCd {
	CUSTOMER_SERVICE_REMARKS = 'CustomerServiceRemarks',
	EXCEPTION_REMARKS = 'ExceptionRemarks'}

